import Typesense from 'typesense';

// Initialize the Typesense client
const client = new Typesense.Client({
    nodes: [
        {
            host: process.env.VUE_APP_TYPESENSE_HOST,
            port: process.env.VUE_APP_TYPESENSE_PORT,
            protocol: process.env.VUE_APP_TYPESENSE_PROTOCOL,
        },
    ],
    apiKey: process.env.VUE_APP_TYPESENSE_API_KEY,
    connectionTimeoutSeconds: 5,
});

// Initialize the collections
const collections = {
    keywords: process.env.VUE_APP_TYPESENSE_KEYWORD,
};

// Export the client and collection names
export { client, collections };
